module.exports = __webpack_public_path__ + "static/img/youxiaSkill.9c0121d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/youxiaSkill.png
// module id = 3OSM
// module chunks = 0